import React, { ReactNode } from "react";

import { Flex, FlexProps } from "@catchoftheday/cg-components";
import { styled, useTheme } from "@catchoftheday/theme";
import { removeProperty } from "@catchoftheday/utilities";

type ProductPriceMainProps = {
  children?: ReactNode;
  onePassExclusive?: boolean;
  onePassSecondary?: boolean;
  hasAside?: boolean;
  hasPromotion?: boolean;
  noArrow?: boolean;
  enabled?: boolean;
  large?: boolean;
} & FlexProps;

export const ProductPriceMain = ({
  children,
  hasAside,
  hasPromotion,
  onePassExclusive,
  onePassSecondary,
  noArrow,
  enabled = true,
  large,
  ...flexProps
}: ProductPriceMainProps) => {
  const content = children || " ";
  const theme = useTheme();

  const memberBackgroundColor = theme.colors.onePass.primary;
  const memberBackgroundColorSecondary = theme.colors.onePass.primaryLighter;

  let backgroundColor: string = theme.colors.error;

  if (onePassExclusive) {
    backgroundColor = memberBackgroundColor;
  } else if (onePassSecondary) {
    backgroundColor = memberBackgroundColorSecondary;
  } else if (!enabled) {
    backgroundColor = "#b7b7b7";
  }

  const arrowImage = `url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2050%20100%22%20preserveAspectRatio%3D%22none%22%3E%3Cpolygon%20points%3D%220%2C%200%2050%2C%2050%200%2C%20100%22%20fill%3D%22%23${backgroundColor.substring(
    1
  )}%22%20%2F%3E%3C%2Fsvg%3E")`;

  const ArrowPriceBox = styled(Flex)`
    &::after {
      content: "";
      display: block;
      position: absolute;
      z-index: 1;
      top: 0;
      bottom: 0;
      left: 100%;
      width: 0.21875em;
      height: 100%;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      ${!hasPromotion && `background-image: ${arrowImage}`}
    }
  `;

  const PriceComponent = noArrow ? Flex : ArrowPriceBox;
  const sizeBuffer = large ? 36 : 0;

  return (
    <PriceComponent
      position="relative"
      justifyContent="center"
      flex="1 0 auto"
      flexDirection="row"
      flexWrap="nowrap"
      minWidth={
        hasAside
          ? `${74 + sizeBuffer}px`
          : onePassSecondary
          ? "0px"
          : `${92 + sizeBuffer}px`
      }
      paddingX="6px"
      alignItems="center"
      padding={large ? "0 10px" : "0 4px"}
      lineHeight="1"
      textAlign="center"
      backgroundColor={backgroundColor}
      color={onePassSecondary ? "onepass.primary" : "white"}
      {...removeProperty(flexProps, "ref")}
    >
      {content}
    </PriceComponent>
  );
};
